// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"f21a7c2a","513":"abe3aa71","703":"132ac492"}[chunkId] + ".chunk.js";
};